export class BenefitCardCornerFlags {
    public static readonly FOR_APPROVAL = "For Approval";
    public static readonly ONGOING = "Ongoing";
    public static readonly ENRLOLLING = "Enrolling";
    public static readonly CANCELLING = "Cancelling";
    public static readonly INVITATION = "Invitation";
    public static readonly COMPLETED = "Completed";
    public static readonly JOINED = "Joined";
    public static readonly EMPTY = "";
}